export enum ScheduleType {
    Daily = 1,
    Weekly = 2,
    ByDate = 3
}